export const locale = {
  lang: 'id',
  data: {
    'SEARCH': {
      'PLACEHOLDER':'Cari ...'
    }
  }
};
